import { render, staticRenderFns } from "./e-commerce.vue?vue&type=template&id=1252f8e0&scoped=true&"
import script from "./e-commerce.vue?vue&type=script&lang=ts&"
export * from "./e-commerce.vue?vue&type=script&lang=ts&"
import style0 from "./e-commerce.vue?vue&type=style&index=0&id=1252f8e0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252f8e0",
  null
  
)

export default component.exports